import FacilityId            from "../../../domain/facility/FacilityId";
import FacilityRepository    from "../../../domain/facility/FacilityRepository";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import Error                 from "../../../domain/fundamentals/message/error/Error";
import ErrorMessage          from "../../../domain/fundamentals/message/error/ErrorMessage";
import ErrorRepository       from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors                from "../../../domain/fundamentals/message/error/Errors";
import ErrorTarget           from "../../../domain/fundamentals/message/error/ErrorTarget";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ErrorDataSource       from "../../../infrastructure/datasource/error/ErrorDataSource";
import FacilityDataSource    from "../../../infrastructure/datasource/facility/FacilityDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import GetFacilities         from "./GetFacilities";

class DeleteFacility {
  constructor(
    private readonly dispatch,
    private readonly facilityRepository: FacilityRepository = new FacilityDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
    private readonly getFacilities: GetFacilities = new GetFacilities(dispatch),
  ) {
  }

  public async execute(facilityId: FacilityId) {
    this.fetchStatusRepository.start();
    try {
      await this.facilityRepository.delete(facilityId);
      await this.getFacilities.execute();
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      const list: Error[] = e.response.data.errors.map((error => new Error(new ErrorTarget(error.target), new ErrorMessage(error.message))));
      this.errorRepository.set(new Errors(list));
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteFacility;
